module.exports = __webpack_public_path__ + "img/taixi.27862948.png";